
import MuiTableBody, { TableBodyProps } from '@mui/material/TableBody';

const EDTableBody = (props: TableBodyProps) => {
  return <MuiTableBody {...props} />;
};

export default EDTableBody;
